<template>
  <div class="purchase-return">
    <second-menu-link-content>
      <template v-slot:header>
        <span>退货单</span>
      </template>
      <template v-slot:content>
        <div class="purchase-return-main">
          <div class="form">
            <el-form :inline="true" :model="form" ref="form" class="form-inline">
              <el-form-item label="退单号/订单号：" label-width="125px" class="w160" prop="orderNumber">
                <el-input
                  placeholder="请输入单号"
                  @keyup.enter.native="screen"
                  v-model="form.orderNumber"
                  class="white"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="客户名称：" class="w160" prop="userName">
                <el-input
                  v-model="form.userName"
                  @keyup.enter.native="screen"
                  placeholder="请输入客户名称"
                  class="white"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="退货状态：" class="w160" prop="state">
                <el-select v-model="form.state" clearable class="select white">
                  <el-option
                    v-for="item in state"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="下单时间：" label-width="125px" prop="date">
                <el-date-picker
                  v-model="form.date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <br />
              <el-form-item class="button">
                <el-button class="btn-blue" @click="screen">筛选</el-button>
                <el-button
                  @click="exportExcel"
                  class="btn-white"
                  v-show="operationList.findIndex(item => item === operationsBtns.roleOrderCancelexport) !== -1"
                >导出报表</el-button>
                <el-button type="text" class="btn-text" @click="resetForm('form')">清空筛选条件</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="table" ref="table">
            <el-table :data="tableData" v-loading="loading">
              <el-table-column prop="refundCode" label="退单号" width="200"></el-table-column>
              <el-table-column prop="date" label="下单时间" width="120"></el-table-column>
              <el-table-column prop="userName" label="客户名称" width="200">
                <template slot-scope="scope">
                  <p :title="scope.row.userName">{{ scope.row.userName }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="backAmount" label="退单金额"></el-table-column>
              <el-table-column prop="statusValue" label="退货状态"></el-table-column>
              <el-table-column prop="orderCode" label="关联订单" width="200"></el-table-column>
              <el-table-column prop="operation" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row.refundCode)" type="text" size="small">查看</el-button>
                  <el-button
                    @click="examine(scope.row.refundCode)"
                    v-if="scope.row.status === 0"
                    type="text"
                    size="small"
                    v-show="operationList.findIndex(item => item === operationsBtns.roleOrderCancelexamine) !== -1"
                  >审核</el-button>
                  <el-button
                    @click="receivingGoods(scope.row.refundCode)"
                    v-if="scope.row.status === 2"
                    type="text"
                    size="small"
                    v-show="operationList.findIndex(item => item === operationsBtns.roleOrderCancelreceive) !== -1"
                  >确认收货</el-button>
                  <el-button
                    @click="receivables(scope.row.refundCode,scope.row.paymentMethod)"
                    v-if="scope.row.status === 3"
                    type="text"
                    size="small"
                    v-show="operationList.findIndex(item => item === operationsBtns.roleOrderCancelreturn) !== -1"
                  >确认退款</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page">
              <pagination-tpl :total="total" :currentPage="page" @queryChange="updatePage"></pagination-tpl>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage"; // 权限数据接口
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBOrder from "models/db/order.js";
import DBExcel from "models/db/excel.js";
const dbOrder = new DBOrder();
const dbExcel = new DBExcel();
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--退单导出  退单审核  退单收货确认 退单退款
      operationsBtns: {
        roleOrderCancelexport: "ROLE_ORDER_cancel_export",
        roleOrderCancelexamine: "ROLE_ORDER_cancel_examine",
        roleOrderCancelreceive: "ROLE_ORDER_cancel_receive",
        roleOrderCancelreturn: "ROLE_ORDER_cancel_return"
      },
      form: {
        orderNumber: "",
        userName: "",
        state: "",
        date: []
      },
      screeningForm: {
        orderNumber: "",
        userName: "",
        state: "",
        date: []
      },
      state: [
        {
          value: 0,
          label: "待退货审核"
        },
        {
          value: 1,
          label: "待退货"
        },
        {
          value: 2,
          label: "待收货"
        },
        {
          value: 3,
          label: "待退款"
        },
        {
          value: 4,
          label: "待收款"
        },
        {
          value: 5,
          label: "已完成"
        },
        {
          value: 6,
          label: "已取消"
        },
        {
          value: 7,
          label: "已拒绝"
        }
      ],
      tableData: [],
      page: 1,
      total: 0,
      loading: true
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  created() {
    this.operationList = getDBOperationPermission();
  },
  beforeMount() {
    if (this.$route.query.status === 0 || this.$route.query.status > 0) {
      this.form.state = Number(this.$route.query.status);
      this.screen();
    } else {
      this.getRefundList();
    }
  },
  methods: {
    // 获取退货单数据
    getRefundList() {
      let searchCode = this.screeningForm.orderNumber;
      let startTime =
        this.screeningForm.date.length > 0 ? this.screeningForm.date[0] : "";
      let endTime =
        this.screeningForm.date.length > 0 ? this.screeningForm.date[1] : "";
      let xbName = this.screeningForm.userName;
      let status = this.screeningForm.state;
      let currentPage = this.page;
      dbOrder
        .getDBRefundList(
          searchCode,
          startTime,
          endTime,
          xbName,
          status,
          currentPage
        )
        .then(res => {
          if (res.success) {
            this.total = res.result.totalNum;
            let arr = [];
            res.result.items.map((value, index, array) => {
              let obj = {};
              obj.id = value.id;
              obj.refundCode = value.refundCode;
              obj.paymentMethod = value.paymentMethod;
              obj.date = this.toDate(value.createTime);
              obj.userName = value.xbName;
              obj.orderAmount = value.totalPrice;
              obj.backAmount = value.realRefundMoney;
              obj.orderCode = value.orderCode;
              obj.statusValue = this.getStatusValue(value.status);
              obj.status = value.status;
              arr.push(obj);
            });
            this.tableData = arr;
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
    },
    // 获取状态码对应的值
    getStatusValue(index) {
      let status = [
        "待退货审核",
        "待退货",
        "待收货",
        "待退款",
        "待收款",
        "已完成",
        "已取消",
        "已拒绝"
      ];
      return status[index];
    },
    // 筛选表单
    screen() {
      this.screeningForm = this.form;
      this.page = 1;
      this.getRefundList();
    },
    // 导出退货单表单
    exportExcel() {
      let searchCode = this.screeningForm.orderNumber;
      let startTime =
        this.screeningForm.date.length > 0 ? this.screeningForm.date[0] : "";
      let endTime =
        this.screeningForm.date.length > 0 ? this.screeningForm.date[1] : "";
      let xbName = this.screeningForm.userName;
      let status = this.screeningForm.state;
      let options = {
        searchCode,
        startTime,
        endTime,
        xbName,
        status
      };
      dbExcel.getRefundOrderExcel(options).then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.screen();
    },
    // 审核
    examine(refundCode) {
      this.$confirm(`是否确认退单${refundCode}通过退单审核`, "退单审核", {
        distinguishCancelAndClose: true,
        confirmButtonText: "通过审核",
        cancelButtonText: "不同意",
        type: "warning"
      })
        .then(() => {
          let res = "1";
          dbOrder.postDBRefundExaminel(refundCode, res).then(res => {
            if (res.success) {
              this.$message.success("审核成功！");
              this.getRefundList();
            }
          });
        })
        .catch(action => {
          if (action === "cancel") {
            let res = "0";
            dbOrder.postDBRefundExaminel(refundCode, res).then(res => {
              if (res.success) {
                this.getRefundList();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        });
    },
    // 确认收货
    receivingGoods(refundCode) {
      this.$confirm(`是否确认退单${refundCode}已收货`, "确认收货", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          dbOrder.postDBRefundReceive(refundCode).then(res => {
            if (res.success) {
              this.$message.success("收货成功！");
              this.getRefundList();
            }
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 确认退款
    receivables(refundCode, paymentMethod) {
      this.$confirm(`是否确认退单${refundCode}发起退款`, "确认退款", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (paymentMethod === 4) {
            dbOrder.getDBEBankRefund(refundCode).then(res => {
              if (res.success) {
                this.$message.success("退款成功！");
                this.getRefundList();
              }
            });
          } else {
            dbOrder.postDBRefundMoney(refundCode).then(res => {
              if (res.success) {
                this.$message.success("退款成功！");
                this.getRefundList();
              }
            });
          }
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 日期转换
    toDate(val) {
      let date = new Date(val);
      var year = date.getFullYear(); // 取得四位数的年份
      var month = date.getMonth() + 1; // 返回0~11之间的数字，0代表一月，11代表12月
      var day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    // 查看商品
    handleClick(refundCode) {
      this.$router.push({
        path: "cancellation-detail",
        query: { refundCode: refundCode }
      });
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.getRefundList();
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-return {
  width: 100%;
  height: 100%;
  .purchase-return-main {
    width: 100%;
    .form {
      padding: 16px 0 8px 15px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      margin-bottom: 24px;
    }
    .table {
      width: 100%;
      .page {
        height: 56px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.purchase-return {
  .purchase-return-main {
    .form {
      .el-form {
        .el-form-item {
          margin-bottom: 16px;
          margin-right: 24px;
        }
        .button {
          padding-left: 125px;
          .el-button + .el-button {
            margin-left: 16px;
          }
          .btn-white {
            width: 128px;
            letter-spacing: 4px;
          }
        }
      }
      .el-form--inline {
        .w160 {
          .el-form-item__content {
            width: 160px;
          }
        }
        .w96 {
          .el-form-item__content {
            width: 96px;
          }
        }
      }
    }
    .table {
      .el-table {
        font-family: "PingFangSC-Regular";
        border: 1px solid #f2f6fc;
        border-bottom: 0;
        border-radius: 8px 8px 0px 0px;
        .el-table__body-wrapper {
          .el-table__body {
            tr {
              td {
                padding: 0px;
                .cell {
                  color: #606266;
                  .name-wrapper {
                    width: 168px;
                    height: 32px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    cursor: pointer;
                  }
                  .el-button {
                    height: 22px;
                    font-size: 12px;
                    line-height: 0;
                    color: #3d74f2;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
